import { OrganizationDetailDto, OrganizationUpdateDto } from './dto/user-managment-dto/organization-detail-dto';
import { OrganizationDto } from './dto/user-managment-dto/organization-dto';
import { WarrantDto } from './dto/user-managment-dto/warrant-dto';
import { OrganizationRequestDto } from './dto/user-managment-dto/organization-request-dto';
import { UserDto } from './dto/user-managment-dto/user-dto';
import applicationApi from '../api';
import { OwnerDto } from './dto/user-managment-dto/owner-dto';
import { OrganizationsOverviewResponseDto } from './dto/user-managment-dto/organization-list-dto';

const createOrganization = async (body: OrganizationRequestDto): Promise<OrganizationDto> => {
  const response = await applicationApi.post('/warrants/organizations', body);
  return response.data;
};

const assignUserToOrganization = async (body: WarrantDto): Promise<WarrantDto> => {
  const response = await applicationApi.put(`/warrants/organizations/${body.organizationId}/users`, { userId:body.userId });
  return response.data;
};

const inviteUsersToOrganization = async (organizationId: string, emails: string[]): Promise<void> => {
  await applicationApi.put(`/warrants/organizations/${organizationId}/invites`, {emails});
};

const fetchUsers =  async (): Promise<UserDto[]> => {
  const response =  await applicationApi.get('/warrants/users');
  return response.data;
}

const fetchOrganizations =  async (): Promise<OrganizationDto[]> => {
  const response =  await applicationApi.get('/warrants/organizations');
  return response.data;
}

const fetchOrganizationsOrderedAlphabetically =  async (): Promise<OrganizationDto[]> => {
  const response =  await applicationApi.get('/warrants/organizations/alphabetically');
  return response.data;
}

const isCurrentUserAdmin = async (): Promise<boolean> => {
  const response = await applicationApi.get(`/warrants/users/me/admin`);
  return response.data;
}

const isCurrentUserAcceptedTerms = async (): Promise<boolean> => {
  const response = await applicationApi.get(`/warrants/users/terms-and-conditions`);
  return response.data;
}

const currentUserHasAcceptedTerms = async (): Promise<void> => {
  await applicationApi.patch(`/warrants/users/terms-and-conditions`);
}

const fetchOwners =  async (): Promise<OwnerDto[]> => {
  const response =  await applicationApi.get('/warrants/seller-owners');
  return response.data;
}

const fetchOrganizationsList = async (params: {
  search?: string;
  cursor?: string;
  action?: string;
  limit?: number;
  pageNumber?: number;
}): Promise<OrganizationsOverviewResponseDto> => {
  const response = await applicationApi.get('/warrants/organizations/list', { params });
  return response.data;
};

const countOrganizations = async (): Promise<number> => {
  const response = await applicationApi.get('/warrants/organizations/count');
  return response.data;
};

const countActiveOrganizations = async (): Promise<number> => {
  const response = await applicationApi.get('/warrants/organizations/status/active/count');
  return response.data;
}

const getOrganizationById = async (id: string): Promise<OrganizationDetailDto> => {
  const response = await applicationApi.get(`/warrants/organizations/${id}`);
  return response.data;
};

const updateOrganization = async (id: string, body: OrganizationUpdateDto): Promise<OrganizationDetailDto> => {
  const response = await applicationApi.patch(`/warrants/organizations/${id}`, body);
  return response.data;
};

export const exportOrganizations = async (organizationsCount: number): Promise<void> => {
  const response = await applicationApi.post(`/warrants/organizations/exports`,
    { organizationsCount },
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'organizations.csv');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

const getCurrentUserOrganization = async (): Promise<OrganizationDto | null> => {
  const response = await applicationApi.get('/warrants/users/me/organization');
  return response.data;
};

export const warrantService = {
  createOrganization,
  assignUserToOrganization,
  fetchUsers,
  fetchOrganizations,
  inviteUsersToOrganization,
  isCurrentUserAdmin,
  isCurrentUserAcceptedTerms,
  currentUserHasAcceptedTerms,
  fetchOwners,
  fetchOrganizationsList,
  countOrganizations,
  countActiveOrganizations,
  getOrganizationById,
  updateOrganization,
  exportOrganizations,
  getCurrentUserOrganization,
  fetchOrganizationsOrderedAlphabetically
};